// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart3_first__kbBV5","second":"Chart3_second__dkQ4y","third":"Chart3_third__14U4d","four":"Chart3_four__x_SXg","five":"Chart3_five__3hdAY"};